<template>
  <div class="box12">
    <pageTitle
      title="实力派讲师天团&nbsp;&nbsp;做你职场的引路人"
     
    />


    <div class="teacher-box">
      <div
        class="teacher"
        v-for="(item, index) in list"
        :key="index"
        :style="
          `backgroundImage: url(` +
          require(`../../../assets/coursePage/linux/box12/0${index + 1}.png`) +
          `)`
        "
        @click="changeCur(index)"
      >
        <div class="tName">{{ item.name }}</div>
        <p v-html="item.p"></p>
      </div>
    </div>

    <van-popup v-model="show" position="bottom" round>
      <div class="pop">
        <div class="pop-top">
          <div class="title">{{ list[this.cur].name }}</div>

          <div class="close" @click="show = false"></div>
        </div>

        <div class="tag-box">
          <div
            class="tag"
          >
            {{ list[this.cur].p }}
          </div>
        </div>

        <p
        
        >
          
          {{ list[cur].info }}
        </p>
        <h2>研发成果</h2>
         <p
        
        >
          {{ list[cur].achievement }}
        </p>
      </div>
    </van-popup>
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
export default {
  components: {
    pageTitle,
  },
  data() {
    return {
      cur: 0,
      show: false,
      list: [
  {
    "name": "王老师",
    "p": "Linux云计算学科讲师",
    "info": "资深DevOps运维开发专家，拥有10年以上Linux平台开发和大型项目架构设计经验，精通Python、Shel等主流编程语言，专注于自动化运维与容器化管理的高效实施。曾主导多个高复杂度项目的运维架构设计，包括湖南武警支队内部系统、人社局平台以及大型生鲜电商系统，全面覆盖从系统规划、性能优化到运维自动化的全流程管理。以深厚的技术功底和创新思维，擅长通过定制化解决方案推动企业数字化转型与业务持续增长。授课风格独具魅力，善于化繁为简，将复杂技术转化为易于理解和操作的知识，深受学员和行业内的高度认可与好评。",
    "achievement": "《自动化运维课程》、《容器化运维课程》、《大型网站系统高可用架构》"
  },
  {
    "name": "赵老师",
    "p": "Linux云计算学科讲师",
    "info": "大数据运维工程师，ApachePulsar社区的活跃贡献者，拥有丰富的大数据运维经验。精通大数据平台的部署、优化与监控，尤其擅长处理高并发、高吞吐量的分布式系统。曾参与多个大规模数据平台的运维架构设计与实施，涵盖电商、金融、出行等行业，具备出色的技术方案落地能力，善于通过自动化工具和最佳实践提升运维效率，确保系统的稳定性和可扩展性，教学风格生动易懂，能够将复杂的大数据运维技术深入浅出地传授给学员。",
    "achievement": "《系统运维课程》、《信创运维课程》、《大数据运维课程》"
  },
  {
    "name": "张老师",
    "p": "传智研究院研究员",
    "info": "资深运维专家，拥有8年运维开发与架构经验，曾任职于51offer留学、老师来了家教等平台，担任研发主管等职务。深入研究过Redis、Elasticsearch、Kafka中间件等技术，并在自动化运维与容器化管理方面有丰富的实践经验。熟悉微服务架构体系，擅长将微服务架构落地到企业生产环境中，提升系统的高可用性与可扩展性。",
    "achievement": "《Redis入门到实战教程》"
  },
  {
    "name": "苗老师",
    "p": "传智研究院研究员",
    "info": "资深运维技术专家，拥有15年研发与运维管理经验，曾担任架构师、项目经理等重要职位，精通Java技术栈、MySQL数据库调优、ElasticSearch、RabbitMQ和Docker等核心运维技术。擅长分布式系统的架构设计、性能优化及自动化运维管理。长期负责大型企业级系统的运维架构设计与实施，曾主导全国党员远程教育系统、云南学分银行系统、郑州地铁CCTV网管系统等多个大型项目的架构规划、运维部署和持续优化工作。以深厚的技术积累和丰富的项目管理经验，确保系统的高可用性、稳定性和可扩展性，推动多个关键项目的顺利上线并持续优化。",
    "achievement": "在线教育项目《学成在线》、生活服务项目《云岚到家》"
  },
  {
    "name": "于老师",
    "p": "传智研究院研究员",
    "info": "资深运维开发专家，拥有11年软件开发及教学经验，曾先后在360、亚信联创、众信旅游等企业担任研发工程师和技术经理。擅长微服务开发与运维，同时在运维领域具备丰富的实践经验，熟悉系统性能优化、自动化运维及容器化管理等技术。在互联网项目中，积累了大量的开发与运维管理经验，能够有效提升系统稳定性和可扩展性。授课逻辑严谨，注重实践与理论相结合，帮助学员在运维和开发领域取得显著进步，广受好评。",
    "achievement": "大型新闻资讯项目《黑马头条》、智慧养老项目《中州养老》"
  },
  {
    "name": "邓老师",
    "p": "传智研究院研究员",
    "info": "资深运维开发专家，曾任汇丰银行研发工程师，负责汇丰银行E&M全球业务的改造升级。拥有10年运维开发经验，具备深厚的技术功底，授课风趣幽默，通俗易懂。精通MySQL、Redis等数据库及缓存技术，并在运维领域有丰富的实践经验。对Solr、ElasticSearch、Dubbo、MQ中间件技术有深入研究，能够在复杂业务场景中结合自动化运维和容器化管理，提升系统稳定性与运维效率。",
    "achievement": "《MySQL数据库入门到精通》"
  }
],
    };
  },
  methods: {
    changeCur(index) {
      this.show = true;
      this.cur = index;
    },
  },
};
</script>

<style lang="scss" scoped>
.box12 {
  padding: 80px 0 58px;
  width: 100%;
  background: url("../../../assets/coursePage/linux/box12/bg.png") no-repeat;
  background-size: 100% 100%;

  .word {
    white-space: nowrap;
  }

  
  .teacher-box {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    margin: 46px 30px 0;
   

    .teacher {
      margin-bottom: 30px;
      padding-left: 24px;
      width: 330px;
      height: 394px;
      background-size: cover;
      background-repeat: no-repeat;
      box-sizing: border-box;
      color: #fff;
      .tName {
        margin-top: 300px;
        font-size: 28px;
        font-family: PingFangSC-Medium;
        font-weight: 500;
        color: #ffffff;
        line-height: 40px;
      }
      p {
        margin-top: 4px;
        font-size: 22px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #ffffff;
        line-height: 28px;
      }
    }
  }

  .pop {
    padding: 40px 46px;
    padding-bottom: 80px;
  
    box-sizing: border-box;
    h2{
        width: 170px;
        box-sizing: border-box;
height: 48px;
      background: #E8F1FF;
border-radius: 0px 32px 32px 24px;
font-family: PingFangSC, PingFang SC;
font-weight: 500;
font-size: 28px;
color: #2674FF;
line-height: 48px;
text-align: center;
font-style: normal;
margin: 32px 0 16px;
    }
  
    .pop-top {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 30px;
      .title {
        height: 48px;
        font-size: 32px;
        font-family: PingFangSC-Semibold;
        font-weight: 600;
        color: #1d2129;
        line-height: 48px;
      }
    }
    .close {
      width: 32px;
      height: 32px;
      background: url("../../../assets/coursePage/ai/box8/close.png") no-repeat;
      background-size: cover;
    }

    .tag-box {
      display: flex;
      flex-wrap: wrap;
      margin-bottom: 24px;
    }

    .tag {
      margin-right: 16px;
      padding: 0px 16px;
      height: 44px;
      text-align: center;
      line-height: 44px;
      background: #e8f3ff;
      border-radius: 8px;

      font-size: 24px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #165dff;
    }

    .tag2 {
      height: 44px;
      background: #fff7e8;
      border-radius: 8px;

      color: #ff7d00;
    }

    p {
      position: relative;
      // display: flex;
      margin-bottom: 16px;
     
      font-size: 28px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #4e5969;
      line-height: 44px;

      span {
        position: absolute;
        top: 16px;
        left: 0px;
        margin-right: 16px;
        min-width: 8px;
        height: 8px;
        background: #becfff;
        border-radius: 50%;
      }
    }
  }
}
</style>
